import React, { createContext, useContext, useEffect, useState } from "react";

// ========== LOCAL DEVELOPMENT BELOW ==========
let USER_API = "/api/user";
let LOGOUT_API = "/auth/logout";
// ========== LOCAL DEVELOPMENT ABOVE ==========

// ========== PRODUCTION BELOW ==========
// USER_API = "https://api.mygourmeto.com/api/user";
// LOGOUT_API = "https://api.mygourmeto.com/auth/logout";
// ========== PRODUCTION ABOVE ==========

if (typeof window !== "undefined") {
  const h = window.location.hostname;
  const isProd = h === "mygourmeto.com" || h === "www.mygourmeto.com";
  if (isProd) {
    USER_API = "https://api.mygourmeto.com/api/user";
    LOGOUT_API = "https://api.mygourmeto.com/auth/logout";
  }
}

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let alive = true;

    const fetchUser = async () => {
      try {
        console.log("[Auth] Fetching user from:", USER_API);
        const res = await fetch(USER_API, {
          credentials: "include",
          cache: "no-store",
          headers: { Accept: "application/json" },
        });

        if (!res.ok) {
          const bodyText = await res.text().catch(() => "");
          console.warn("[Auth] /api/user non-OK:", res.status, bodyText);
          if (alive) {
            setUser(null);
            setError(`HTTP ${res.status}`);
          }
          return;
        }

        const data = await res.json().catch(() => ({}));
        if (alive) {
          setUser(data?.user || null);
          setError(null);
        }
      } catch (e) {
        console.error("[Auth] Failed to fetch user:", e);
        if (alive) {
          setUser(null);
          setError("NETWORK_ERROR");
        }
      } finally {
        if (alive) setLoading(false);
      }
    };

    fetchUser();
    return () => {
      alive = false;
    };
  }, []);

  const logout = async () => {
    try {
      await fetch(LOGOUT_API, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
      });
    } catch (_) {
      // ignore
    } finally {
      setUser(null);
    }
  };

  return (
    <AuthContext.Provider value={{ user, setUser, loading, error, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
